// extracted by mini-css-extract-plugin
export default {"clockText":"Clock_clockText__Umznm"};